<template>
	<div>
        <b-container class="py-5 pt-xl-0">

          <b-card class="p-3">
			<h2 class="bolder">Mis datos</h2>
            <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                <b-row>
                    <!-- Item -->
                    <b-col cols="6">
                        <b-form-group id="input-group-1" label="Nombres" label-for="input-1">
                            <b-form-input
							class="template-radius"
                            id="input-1"
                            v-model="form.names"
                            :readonly="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <!-- Item -->
                    <b-col cols="6">
                        <b-form-group id="input-group-2" label="Apellidos" label-for="input-2">
                            <b-form-input
							class="template-radius"
                            id="input-2"
                            v-model="form.lastNames"
                            :readonly="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <!-- Item -->
                    <b-col cols="6">
                        <b-form-group id="input-group-3" :label="country == 0 ? 'Dni' : 'Rut'" label-for="input-3">
                            <b-form-input
							class="template-radius"
                            id="input-3"
                            v-model="form.rut"
                            :readonly="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <!-- Item -->
                    <b-col cols="6">
                        <b-form-group id="input-group-4" label="Razón Social" label-for="input-4">
                            <b-form-input
							class="template-radius"
                            id="input-4"
                            v-model="form.razonSocial"
                            :readonly="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <!-- Item -->
                    <b-col cols="6">
                        <b-form-group id="input-group-5" label="Fecha de Nacimiento" label-for="input-5">
                            <b-form-datepicker
							class="template-radius"
                            id="input-5"
                            v-model="form.bornDate" locale="es-ES" label-no-date-selected="Seleccionar fecha"
                            ></b-form-datepicker>
                        </b-form-group>
                    </b-col>
                    <!-- Item -->
                    <b-col cols="6">
                        <b-form-group id="input-group-6" label="Sexo" label-for="input-6">
                            <b-form-select
							class="template-radius"
                            id="input-6"
                            v-model="form.gender"
                            :options="genders"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <!-- Item -->
                    <b-col cols="6">
                        <b-form-group id="input-group-7" label="Teléfono" label-for="input-7">
                            <b-form-input
							class="template-radius"
                            id="input-7"
                            v-model="form.telephone"
                            :readonly="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <!-- Item -->
                    <b-col cols="6">
                        <b-form-group id="input-group-8" label="Teléfono Móvil" label-for="input-8">
                            <b-form-input
							class="template-radius"
                            id="input-8"
                            v-model="form.phone"
                            :readonly="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <!-- Item -->
                    <b-col cols="6">
                        <b-form-group id="input-group-9" label="Profesión" label-for="input-9">
                            <b-form-input
							class="template-radius"
                            id="input-9"
                            v-model="form.profession"
                            :readonly="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <!-- Item -->
                    <b-col cols="6">
                        <b-form-group id="input-group-12" label="Nacionalidad" label-for="input-12">
                            <b-form-input
							class="template-radius"
                            id="input-12"
                            v-model="form.nationality"
                            :readonly="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <!-- Item -->
                    <b-col cols="6">
                        <b-form-group id="input-group-10" label="Estado Civil" label-for="input-10">
                            <b-form-select
							class="template-radius"
                            id="input-10"
                            v-model="form.estadoCivil"
                            :options="estadosCiviles"
                            :readonly="true"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <!-- Item -->
                    <b-col cols="6" v-if="form.estadoCivil == 'Casado(a)'">
                        <b-form-group id="input-group-11" label="Regimen Patrimonial" label-for="input-11">
                            <b-form-select
							class="template-radius"
                            id="input-11"
                            v-model="form.regimenPatrimonial"
                            :options="regimenPatriomonialOpciones"
                            :readonly="true"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <!-- Item -->
                    <b-col cols="6" v-if="form.estadoCivil == 'Casado(a)'">
                        <b-form-group id="input-group-13" label="Nombres Cónyuges" label-for="input-13">
                            <b-form-input
							class="template-radius"
                            id="input-13"
                            v-model="form.spouseNames"
                            :readonly="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <!-- Item -->
                    <b-col cols="6" v-if="form.estadoCivil == 'Casado(a)'">
                        <b-form-group id="input-group-14" label="Apellidos Cónyuges" label-for="input-14">
                            <b-form-input
							class="template-radius"
                            id="input-14"
                            v-model="form.spouseLastNames"
                            :readonly="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <!-- Item -->
                </b-row>
                <b-row>
                  <b-col>
                    <b-card bg-variant="info" text-variant="white" header="Escribe tu contraseña solo en caso de que desees cambiarla." class="text-center my-3 template-radius">
                    </b-card>
                  </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="input-password" label="Contraseña" label-for="input-12">
                            <b-form-input
							class="template-radius"
                            id="input-15"
                            v-model="form.password"
                            type="password"
                            :state="validLengh"
                            ></b-form-input>
                           <b-form-invalid-feedback id="input-password">
                            La Contraseña tener un largo mayor o igual a 6 caracteres
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <!-- Item -->
                    <b-col cols="6">
                        <b-form-group id="input-confirm-password" label="Confirmar Contraseña" label-for="input-12">
                            <b-form-input
							class="template-radius"
                            id="input-16"
                            v-model="form.passwordConfirmation"
                            type="password"
                            :state="validPassword"
                            ></b-form-input>
                            <b-form-invalid-feedback id="input-confirm-password">
                            Las contraseñas deben ser idénticas
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row>
               <!-- Buttons -->
                <b-row>
                    <b-col cols="12" class="text-right">
                        <b-button squared type="submit" class="btn-br btn-cerrar-sesion border-left-br px-4 py-2">Editar</b-button>
                    </b-col>
                </b-row>
            </b-form>

            <!-- Results
            <b-card class="mt-3" header="Form Data Result">
            <pre class="m-0">{{ form }}</pre>
            </b-card>
            -->
          </b-card>
        </b-container>
    </div>
</template>
<script>
  export default {
    name: 'information',
    data() {
      return {
        form: {
          names: '',
          lastNames: '',
          rut: '',
          razonSocial: '',
          bornDate: '',
          gender: '',
          telephone: '',
          phone: '',
          profession: '',
          estadoCivil: 'Soltero(a)',
          regimenPatrimonial: 'Ganancial',
          nationality: '',
          spouseNames: '',
          spouseLastNames: '',
          password: '',
          passwordConfirmation: ''
        },
        genders: ['MASCULINO', 'FEMENINO', 'NO BINARIE'],
        estadosCiviles: ['Soltero(a)', 'Casado(a)', 'Viudo(a)', 'Divorciado(a).', 'Conviviente civil.'],
        regimenPatriomonialOpciones: ['Ganancial', 'Separación de bienes', 'Participación'],
        show: true
      }
    },
    beforeMount(){
        this.form.names = this.$auth.watch.data.name
        this.form.lastNames  = this.$auth.watch.data.lastname
        this.form.rut  = this.$auth.watch.data.rut
        this.form.nationality  = this.$auth.watch.data.nationality
        this.getData()
    },
    methods: {
      getData(){
		this.axios.get("users/get").then(result => {
            this.form.estadoCivil = result.data.estadoCivil
            this.form.telephone = result.data.telephone
            this.form.phone = result.data.phone
            this.form.nationality = result.data.nationality
            this.form.profession = result.data.profession
            this.form.bornDate = result.data.bornDate
            this.form.spouseNames = result.data.spouseNames
            this.form.spouseLastNames = result.data.spouseLastNames
            this.form.regimenPatrimonial = result.data.regimenPatrimonial
            this.form.gender = result.data.gender
        })
      },
      onSubmit(event) {
        event.preventDefault()
        if(this.form.estadoCivil != 'Casado(a)'){
            this.form.regimenPatrimonial = null;
            this.form.spouseNames = '';
            this.form.spouseLastNames = '';
        }
		this.axios.patch("users/edit", {user: this.form}).then(() => {
            this.$swal('Éxito', 'usuario editado con éxito', 'success');
        }).error( () =>{
            this.$swal('Oops', 'hubo un error editando', 'error');
        })
      },
      onReset(event) {
        event.preventDefault()
        // Reset our form values
        this.form.names = ''
        this.form.lastNames = ''
        this.form.rut = ''
        this.form.razonSocial = ''
        this.form.bornDate = ''
        this.form.gender = 'Masculino'
        this.form.telephone = ''
        this.form.phone = ''
        this.form.profession = ''
        this.form.estadoCivil = 'Soltero/a'
        this.form.regimenPatrimonial = null
        this.form.nationality = ''
        this.form.spouseNames = ''
        this.form.spouseLastNames = ''
        // Trick to reset/clear native browser form validation state
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      }
    },
    computed: {
      validPassword() {
        if(this.form.password.length == 0)
            return true
        return this.form.password == this.form.passwordConfirmation && this.form.passwordConfirmation.length >= 6 ? true : false
      },
      validLengh() {
        if(this.form.password.length == 0)
            return true
        return this.form.password.length >= 6 ? true : false
      },
			country() {
				return this.$store.getters.getCustomerData ? this.$store.getters.getCustomerData.country : 0;
			},
    },
  }
</script>
<style>
</style>
